import { api } from "../axios";

// get pet vet by id
export const getPetVetTherapistById = async (id) => await api.get(`/archive/getVetTherapistById/${id}`);

export default {
  getPetVetTherapistById
}